export enum CommissionType {
    PERCENTAGE = 'percentage',
    FIXED = 'fixed'
}
